import { put } from "redux-saga/effects";

import { message } from "antd";

import { SchoolAction } from "../actions";
import { ApiCaller } from "../../config";

export default class SchoolMiddleware {
  static *getSchools({ payload, cb }) {
    try {
      const { search, status, limit, offset } = payload;

      const res = yield ApiCaller.Get(
        `/school/search-school?search=${search ?? ""}&status=${
          status ?? ""
        }&limit=${limit ?? ""}&offset=${offset ?? ""}`
      );

      if (res.status === 200) {
        yield put(SchoolAction.getSchoolsSuccess(res.data.data));
      } else {
        yield put(SchoolAction.getSchoolsSuccess([]));
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(SchoolAction.getSchoolsFailure());
    }
  }
  static *getSchool({ payload, cb }) {
    try {
      const res = yield ApiCaller.Get(`/get-schoolDetails/${payload?.id}`);

      if (res.status === 200) {
        yield put(SchoolAction.getSchoolSuccess(res.data.data));
      } else {
        yield put(SchoolAction.getSchoolFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(SchoolAction.getSchoolFailure());
    }
  }
  static *editSchool({ payload, cb }) {
    try {
      const res = yield ApiCaller.Put(`/school/edit-school`, payload);

      if (res.status === 200) {
        yield put(SchoolAction.editSchoolSuccess(res.data.data));
        message.success(res?.data?.message);
      } else {
        yield put(SchoolAction.editSchoolFailure());
        message.success(res?.data?.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(SchoolAction.editSchoolFailure());
    }
  }
  static *addSchool({ payload, cb }) {
    try {
      const res = yield ApiCaller.Put(`/school/add-school`, payload);

      if (res.status === 200) {
        yield put(SchoolAction.addSchoolSuccess(res.data.data));
        message.success(res?.data?.message);
      } else {
        yield put(SchoolAction.addSchoolFailure());
        message.success(res?.data?.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(SchoolAction.addSchoolFailure());
    }
  }
  static *changeSchoolStatus({ payload, cb }) {
    try {
      const res = yield ApiCaller.Put(
        `/school/change-school-status?userId=${payload?.userId}&status=${payload?.status}`
      );

      if (res.status === 200) {
        yield put(SchoolAction.changeSchoolStatusSuccess(res.data.data));
        message.success(res?.data?.message);
      } else {
        yield put(SchoolAction.changeSchoolStatusFailure());
        message.success(res?.data?.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(SchoolAction.changeSchoolStatusFailure());
    }
  }
}
